import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Layout } from '../components/Layout';
import axios from 'axios';
import { toast } from 'react-toastify';

export const Register = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [referrerInfo, setReferrerInfo] = useState(null);
  const [captcha, setCaptcha] = useState({ num1: 5, num2: 7 });
  const [form, setForm] = useState({
    full_name: '',
    phone: '',
    email: '',
    password: '',
    gender: '',
    referred_by: searchParams.get('reff') || '',
    captcha_answer: ''
  });

  useEffect(() => {
    if (form.referred_by) {
      // Cek validasi referral
      axios.get(`/api/auth/check-referral?code=${form.referred_by}`)
        .then(res => {
          if (res.data.success) {
            setReferrerInfo(res.data.data);
          }
        })
        .catch(() => {
          toast.error('Kode referral tidak valid!');
          setForm(prev => ({ ...prev, referred_by: '' }));
        });
    }
  }, [form.referred_by]);

  const refreshCaptcha = () => {
    setCaptcha({
      num1: Math.floor(Math.random() * 20) + 1,
      num2: Math.floor(Math.random() * 20) + 1
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validasi captcha
    const userAnswer = parseInt(form.captcha_answer);
    if (userAnswer !== captcha.num1 + captcha.num2) {
      toast.error('❌ Jawaban captcha salah!');
      refreshCaptcha();
      return;
    }

    if (!form.referred_by) {
      toast.error('⚠️ Wajib menggunakan link referral!');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/api/auth/register', form);
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        toast.success('✅ Registrasi berhasil!');
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Registrasi gagal!');
    }
    setLoading(false);
  };

  return (
    <Layout title="📝 Registrasi" subtitle="Wajib pakai link referral" showBack>
      <div className="tg-card">
        {referrerInfo && (
          <div className="tg-alert tg-alert-success">
            👤 DIREFERRAL OLEH: <strong>{referrerInfo.full_name}</strong>
            <br /><small style={{ color: 'var(--tg-gray)' }}>Kode: {form.referred_by}</small>
          </div>
        )}

        {!form.referred_by && (
          <div className="tg-alert tg-alert-error">
            ⚠️ <strong>Wajib menggunakan link referral!</strong>
            <br /><small>Contoh: https://ojesi.cafee.id/register?reff=CODE</small>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input type="hidden" name="referred_by" value={form.referred_by} />
          
          <div className="tg-input-group">
            <label>Nama Lengkap <span style={{ color: 'var(--tg-red)' }}>*</span></label>
            <input 
              className="tg-input" 
              placeholder="Masukkan nama lengkap" 
              value={form.full_name}
              onChange={(e) => setForm({...form, full_name: e.target.value})}
              required
            />
          </div>

          <div className="tg-input-group">
            <label>Nomor HP <span style={{ color: 'var(--tg-red)' }}>*</span></label>
            <input 
              className="tg-input" 
              placeholder="081234567890" 
              value={form.phone}
              onChange={(e) => setForm({...form, phone: e.target.value})}
              required
            />
          </div>

          <div className="tg-input-group">
            <label>Email</label>
            <input 
              className="tg-input" 
              type="email"
              placeholder="email@domain.com" 
              value={form.email}
              onChange={(e) => setForm({...form, email: e.target.value})}
            />
          </div>

          <div className="tg-input-group">
            <label>Password <span style={{ color: 'var(--tg-red)' }}>*</span></label>
            <input 
              className="tg-input" 
              type="password"
              placeholder="Minimal 6 karakter" 
              value={form.password}
              onChange={(e) => setForm({...form, password: e.target.value})}
              required
              minLength={6}
            />
          </div>

          <div className="tg-input-group">
            <label>Gender <span style={{ color: 'var(--tg-red)' }}>*</span></label>
            <select 
              className="tg-input" 
              value={form.gender}
              onChange={(e) => setForm({...form, gender: e.target.value})}
              required
            >
              <option value="">Pilih Gender</option>
              <option value="pria">👨 Pria</option>
              <option value="wanita">👩 Wanita</option>
            </select>
          </div>

          <div className="tg-input-group">
            <label>🔢 Verifikasi CAPTCHA <span style={{ color: 'var(--tg-red)' }}>*</span></label>
            <div style={{ background: 'rgba(255,255,255,0.03)', padding: '16px', borderRadius: '8px', textAlign: 'center' }}>
              <div style={{ fontSize: '24px', fontWeight: '700' }}>
                {captcha.num1} + {captcha.num2} = ?
              </div>
              <div style={{ fontSize: '12px', color: 'var(--tg-gray)', marginTop: '4px' }}>
                Masukkan hasil penjumlahan
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginTop: '8px' }}>
                <input 
                  className="tg-input" 
                  style={{ width: '120px', textAlign: 'center', fontSize: '18px' }} 
                  placeholder="?"
                  value={form.captcha_answer}
                  onChange={(e) => setForm({...form, captcha_answer: e.target.value})}
                  required
                />
                <button 
                  type="button" 
                  className="tg-btn tg-btn-outline" 
                  style={{ width: 'auto', padding: '8px 16px' }}
                  onClick={refreshCaptcha}
                >
                  🔄
                </button>
              </div>
            </div>
          </div>

          <button type="submit" className="tg-btn tg-btn-primary" disabled={loading || !form.referred_by}>
            {loading ? 'Loading...' : '✅ Daftar Sekarang'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px', color: 'var(--tg-gray)' }}>
          Sudah punya akun? <Link to="/login" className="tg-link">Login di sini</Link>
        </div>
      </div>
    </Layout>
  );
};
